export default [
	{
		path: "/client/members",
		exact: true,
		component: "Members",
		load: true,
	},
];
